import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import Modal from '../../Components/Modals/Modal';
import DispatchEmployeesList from '../../Components/Lists/DispatchEmployeesList';
import DispatchToolboxesList from '../../Components/Lists/DispatchToolboxesList';
import {
  selectAllEmployees,
  selectAllToolboxes,
  selectAllTrucks,
  selectAllJobs,
  selectAllOccupiedEmployees,
  selectAllOccupiedToolboxes,
  selectAllOccupiedTrucks,
  selectAllOccupiedCaptains,
} from '../Dispatch/selectors';
import { updateDispatch } from '../Dispatch/actions';
import DispatchTrucksList from '../../Components/Lists/DispatchTrucksList';
import DispatchJobsList from '../../Components/Lists/DispatchJobsList';
import DispatchCaptainsList from '../../Components/Lists/DispatchCaptainsList';

class DispatchItemAdder extends Component {
  constructor(props) {
    super(props);
    this.handleUpdateModalState = this.handleUpdateModalState.bind(this);
    this.state = {
      employees: [],
      jobs: [],
      jobsToAdd: [],
      toolboxes: [],
      trucks: [],
      captain_id: null,
      note: '',
    };
  }

  componentDidMount() {
    const { teams } = this.props;
    const currentJobs = this.getCurrentJobs(teams);
    this.setState({ currentJobs });
  }

  // Reset modal state when closed or opened
  componentWillReceiveProps(nextProps) {
    if (nextProps.team !== this.props.team && nextProps.team) {
      const currentJobs = this.getCurrentJobs(nextProps.teams);
      this.setState({
        employees: nextProps.team.employees ? nextProps.team.employees : [],
        jobs: nextProps.team.jobs ? nextProps.team.jobs : [],
        toolboxes: nextProps.team.toolboxes ? nextProps.team.toolboxes : [],
        trucks: nextProps.team.trucks ? nextProps.team.trucks : [],
        captain_id: nextProps.team.captain_id
          ? nextProps.team.captain_id
          : null,
        note: nextProps.team.note ? nextProps.team.note : '',
        currentJobs,
      });
    }
  }

  handleUpdateModalState = object => {
    this.setState(object);
  };

  handleCloseClick = () => {
    const { handleToggleModal, onUpdateDispatch, team } = this.props;

    const updatedTeam = { ...team, ...this.state };
    delete updatedTeam.currentJobs;

    onUpdateDispatch(updatedTeam);
    this.setState({
      jobsToAdd: [],
    });
    handleToggleModal();
  };

  buttons = () => {
    return (
      <div>
        <button
          type="button"
          className="btn btn-primary header-modal-btn"
          onClick={this.handleCloseClick}
        >
          SAUVEGARDER
        </button>
      </div>
    );
  };

  getCurrentJobs = teams => {
    const { teamJobs } = this.props;
    const toReturn = [];
    try {
      for (let team in teams) {
        teams[team].jobs.forEach(job => {
          if (teamJobs[job]) {
            toReturn.push(teamJobs[job].job_reference);
          }
        });
      }
    } catch (e) {
      console.log(e);
    }

    return toReturn;
  };

  tabsContent = () => {
    const {
      activeTab,
      employees,
      toolboxes,
      trucks,
      jobs,
      occupiedEmployees,
      occupiedToolboxes,
      occupiedTrucks,
      occupiedCaptains,
      activeTeam,
    } = this.props;
    const selectedEmployees = this.state.employees;
    const selectedToolboxes = this.state.toolboxes;
    const selectedTrucks = this.state.trucks;
    const selectedJobs = this.state.jobsToAdd;
    const currentJobs = this.state.currentJobs;
    // const selectedJobs = team ? jobs.filter(a => team.tmp_jobs_ids.indexOf(a.id > -1)) : [];
    const selectedCaptainID = this.state.captain_id;
    const note = this.state.note;
    const occupiedEmployeesAndCapitains = occupiedEmployees.concat(
      occupiedCaptains,
    );

    switch (activeTab) {
      case 0:
        return (
          <DispatchEmployeesList
            employees={employees}
            selectedEmployees={selectedEmployees}
            handleUpdateModalState={this.handleUpdateModalState}
            occupiedEmployees={occupiedEmployeesAndCapitains}
          />
        );
      case 1:
        return (
          <DispatchCaptainsList
            employees={employees}
            selectedCaptainID={selectedCaptainID}
            handleUpdateModalState={this.handleUpdateModalState}
            occupiedCaptains={occupiedEmployeesAndCapitains}
          />
        );
      case 2:
        return (
          <DispatchToolboxesList
            toolboxes={toolboxes}
            trucks={selectedTrucks}
            selectedToolboxes={selectedToolboxes}
            handleUpdateModalState={this.handleUpdateModalState}
            occupiedToolboxes={occupiedToolboxes}
          />
        );
      case 3:
        return (
          <DispatchTrucksList
            trucks={trucks}
            toolboxes={selectedToolboxes}
            selectedTrucks={selectedTrucks}
            handleUpdateModalState={this.handleUpdateModalState}
            occupiedTrucks={occupiedTrucks}
          />
        );
      case 4:
        return (
          <textarea
            className="form-control dispatch-text-area"
            defaultValue={note}
            onChange={e =>
              this.handleUpdateModalState({ note: e.target.value })
            }
          />
        );
      case 5:
        return (
          <DispatchJobsList
            currentJobs={currentJobs}
            jobs={jobs}
            activeTeam={activeTeam}
            selectedJobs={selectedJobs}
            handleUpdateModalState={this.handleUpdateModalState}
          />
        );
      default:
        return null;
    }
  };

  content = () => {
    let tabs = [
      'Ouvriers',
      'Contremaitre',
      'Coffres',
      'Camions',
      'Notes',
      'Jobs',
    ];
    const { activeTab, handleChangeModalTab } = this.props;

    return (
      <div>
        <ul className="nav nav-tabs" role="tablist">
          {tabs.map((tab, index) => (
            <li
              onClick={() => handleChangeModalTab(index)}
              style={{ cursor: 'pointer' }}
              className={activeTab === index ? 'active' : ''}
              key={index}
            >
              <a>{tab}</a>
            </li>
          ))}
        </ul>
        {this.tabsContent()}
      </div>
    );
  };

  render() {
    return (
      <Modal
        {...this.props}
        buttons={this.buttons}
        title="Ajout d'items"
        content={this.content()}
      />
    );
  }
}

DispatchItemAdder.propTypes = {
  handleChangeModalTab: PropTypes.func,
  handleToggleModal: PropTypes.func,
  activeTab: PropTypes.number,
  employees: PropTypes.array,
  toolboxes: PropTypes.array,
  trucks: PropTypes.array,
  jobs: PropTypes.array,
};

const mapStateToProps = state => ({
  employees: selectAllEmployees(state),
  toolboxes: selectAllToolboxes(state),
  trucks: selectAllTrucks(state),
  jobs: selectAllJobs(state),
  teamJobs: state.dispatch.teamJobs,
  teams: state.dispatch.teams,
  activeTeam: state.dispatch.teams[state.ui.activeTeamID],
  occupiedEmployees: selectAllOccupiedEmployees(state),
  occupiedToolboxes: selectAllOccupiedToolboxes(state),
  occupiedTrucks: selectAllOccupiedTrucks(state),
  occupiedCaptains: selectAllOccupiedCaptains(state),
});

const mapDispatchToProps = dispatch => ({
  onUpdateDispatch: team => dispatch(updateDispatch(team)),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(withConnect)(DispatchItemAdder);
